import { useTheme } from '@mui/material/styles';
import { getComponentStyles } from '../themes/componentStyles';

/**
 * Custom hook to access themed component styles
 * @returns {Object} Component style objects
 */
export const useComponentStyles = () => {
	const theme = useTheme();
	return getComponentStyles(theme);
};
